import { v4 as uuidv4 } from "uuid";
import { Check } from "../check";
import { CheckDto } from "../check-dto";
import { OrderPayment } from "../order";
import { EGiftCardPool } from "./EGiftCardPool.model";
import { EGiftVenue } from "./EGiftVenue.model";

export class EGiftTransaction {
	key: string = uuidv4();
	venueKey: number;
	value: number;
	transactionDateTime: Date;
	transactionAmount: number;
	promoCode: string;
	purchaserEmail: string;
	purchaserFirstName: string;
	purchaserLastName: string;
	purchaserZipcode: string;
	recipientName: string;
	recipientEmail: string;
	recipientFirstName: string;
	recipientLastName: string;
	note: string;
	sendDateTime: Date;
	delaySend: boolean;
	sent: boolean;
	activated: boolean;
	invoice: string;
	token: string;
	checkKey: string;

	cardNumber: string;
	currentBalance: number;
	balanceCheckCompleted: boolean;
	activationUrl: string;

	EGiftVenue: EGiftVenue;

	orderPayment: OrderPayment;
	check: CheckDto;

	EGiftCardPool: EGiftCardPool;

	CheckV2: Check;

	public constructor(init?: Partial<EGiftTransaction>) {
		Object.assign(this, init);
	}
}
